import axios from 'axios';

const client = axios.create({
  withCredentials: true,
});

axios.defaults.timeout = 30000;

export default client;
